export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center gap-16">
          <div className="w-[45%]">
            <div className="rounded-[32px] overflow-hidden shadow-2xl aspect-[4/3]">
              <img
                src="https://public.readdy.ai/ai/img_res/02e17c3dbace332fdd630c2df3d454af.jpg"
                alt="Technology Innovation"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-[55%] pl-12">
            <div className="inline-block bg-[#e8f4f8] px-5 py-2 rounded-full mb-8">
              <span className="text-xs font-semibold text-[#2c5282] tracking-wider">WHO WE ARE</span>
            </div>

            <h2 className="text-5xl font-bold leading-tight mb-10">
              <div className="text-[#1a202c]">ROLI SH.P.K.</div>
              <div className="text-[#1a202c] mt-2">
                Mobile Innovation <span className="text-[#718096]">Team</span>
              </div>
            </h2>

            <p className="text-lg text-[#4a5568] leading-relaxed max-w-xl mb-9">
              A team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>

            <div className="w-20 h-0.5 bg-[#3182ce]"></div>
          </div>
        </div>
      </div>
    </section>
  );
}